import { FETCH_VISITS_SUBMITTED_FOR_TYPING_ERROR, FETCH_VISITS_SUBMITTED_FOR_TYPING_START, FETCH_VISITS_SUBMITTED_FOR_TYPING_SUCCESS, LOCK_SUBMITTED_FOR_TYPING_VISIT_SUCCESS, SET_AUTO_NEXT_VISIT, SET_FOR_TYPING_SEARCH_FILTER_AND_SORT, UNLOCK_SUBMITTED_FOR_TYPING_VISIT_SUCCESS, SET_WORKLIST_PAGINATION, LOCK_SUBMITTED_FOR_TYPING_VISIT_START, LOCK_SUBMITTED_FOR_TYPING_VISIT_ERROR, VIEW_SUBMITTED_FOR_TYPING_VISIT_SUCCESS, VIEW_SUBMITTED_FOR_TYPING_VISIT_ERROR, RESET_FOR_TYPING_FILTER } from '../../actions/typist/typistWorklistAction';
import { paginationSize } from '../../../constants/constants';
import _ from 'lodash';

const INIT_STATE = {
    error: "",
    loading: false,
    unlocking: false,
    message: '',
    visits: [],
    searchFilter: {
        searchText: "",
        mipIds: [],
        modalityIds: [],
        risId: 1,
        startDate: null,
        endDate: null,
    },
    sortConditions: [{ sortBy: "priority", dataType: "STRING", sortType: "asc" }],
    autoNextVisit: false,
    pagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0,
    },
    skippedVisits: []
};

const typistWorklistReducer = (state = INIT_STATE, action) => {
    let newVisits;
    let index;
    switch (action.type) {
        case SET_FOR_TYPING_SEARCH_FILTER_AND_SORT: {
            return {
                ...state,
                searchFilter: { ...state.searchFilter, ...action.payload.searchFilter },
                sortConditions: action.payload.sortConditions.length > 0 ? [...action.payload.sortConditions] : [],
                skippedVisits: action.payload.skippedVisits.length > 0 ? [...action.payload.skippedVisits] : []
            }
        }
        case FETCH_VISITS_SUBMITTED_FOR_TYPING_START: {
            return { ...state, error: '', message: '', found: false, loading: true };
        }
        case FETCH_VISITS_SUBMITTED_FOR_TYPING_SUCCESS: {
            return { ...state, error: '', message: '', found: false, loading: false, visits: action.visits };
        }
        case FETCH_VISITS_SUBMITTED_FOR_TYPING_ERROR: {
            return { ...state, error: '', message: '', found: false, loading: false };
        }
        case LOCK_SUBMITTED_FOR_TYPING_VISIT_START: {
            return { ...state, loading: true };
        }
        case LOCK_SUBMITTED_FOR_TYPING_VISIT_SUCCESS: {
            newVisits = [...state.visits];
            index = newVisits.findIndex(obj => obj.reportId === action.visit.reportId && obj.visitNo === action.visit.visitNo);
            if (index > -1) {
                newVisits.splice(index, 1, { ...newVisits[index], ...action.visit });
            }
            return { ...state, visits: [...newVisits] };
        }
        case LOCK_SUBMITTED_FOR_TYPING_VISIT_ERROR: {
            return { ...state, loading: false };
        }
        case UNLOCK_SUBMITTED_FOR_TYPING_VISIT_SUCCESS: {
            let newVisits = [...state.visits];
            index = newVisits.findIndex(obj => obj.reportId === action.visit.reportId && obj.visitNo === action.visit.visitNo);
            if (index > -1) {
                newVisits.splice(index, 1, { ...newVisits[index], lockedBy: null });
            }
            return { ...state, visits: [...newVisits] };
        }
        case SET_AUTO_NEXT_VISIT: {
            return { ...state, autoNextVisit: action.autoNextVisit };
        }

        case SET_WORKLIST_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }
        case VIEW_SUBMITTED_FOR_TYPING_VISIT_SUCCESS: {
            return { ...state, loading: false };
        }
        case VIEW_SUBMITTED_FOR_TYPING_VISIT_ERROR: {
            return { ...state, loading: false };
        }
        case RESET_FOR_TYPING_FILTER: {
            let newState = _.cloneDeep(state);
            newState.searchFilter.searchText = null;
            newState.searchFilter.startDate = null;
            newState.searchFilter.endDate = null;
            return { ...newState };
        }
        default:
            return state;
    }
}

export default typistWorklistReducer;
